exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animated-image__sample-image[data-v-2a85f83c]{width:150px;height:150px}.row--mb-20[data-v-2a85f83c]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a85f83c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/grad-images/checkout-download/components/AnimatedImage.vue
// module id = 1609
// module chunks = 3